import React from 'react';
import { MapContainer, TileLayer, Circle, Tooltip } from 'react-leaflet';

// Echte Landkarte (Leaflet) mit farbigen Zonen-Rechtecken = Live-Marktlage je Zone.
// Farbe nach ρ (grün=Push/günstig … rot=Surge/knapp), leicht transparent → Karte bleibt sichtbar.
// Tooltip je Zelle zeigt ρ + Faktor (Surge/Push) + Anfragen/Fahrer.
const DUISBURG = [51.435, 6.762];
const HEAT = ['#15803d', '#86efac', '#6b7280', '#f59e0b', '#dc2626'];
const LBL = ['Push (günstig)', 'mild Push', 'neutral', 'mild Surge', 'Surge (knapp)'];
const rhoLevel = (rho) => rho >= 1.3 ? 4 : rho >= 1.05 ? 3 : rho >= 0.9 ? 2 : rho >= 0.7 ? 1 : 0;
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

// Faktor aus ρ — spiegelt voogo-engine.dynamicFactor (Totband + Stufen + Deckel / Push-Boden), nur zur Anzeige.
function factorOf(rho, d) {
  if (!d) return null;
  const up = d.surgeStartRho != null ? d.surgeStartRho : 1;
  if (rho > up) {
    let f = clamp(1 + (d.kUp != null ? d.kUp : 0.15) * (rho - up), 1, d.surgeCap != null ? d.surgeCap : 1.25);
    const s = d.surgeStep;
    if (s && s > 0) f = Math.min(d.surgeCap != null ? d.surgeCap : 1.25, Math.round((f - 1) / s) * s + 1);
    return Math.round(f * 100) / 100;
  }
  if (rho < 1) return Math.round(clamp(1 - (d.kDown != null ? d.kDown : 0.30) * (1 - rho), d.pushFloor != null ? d.pushFloor : 0.85, 1) * 100) / 100;
  return 1;
}

export default function EngineHeatmap({ zones, cell = 0.02, dyn }) {
  const cells = (zones || [])
    .map(z => { const [a, b] = String(z.zone).split('_').map(Number); return { ...z, lat: a * cell, lng: b * cell }; })
    .filter(c => Number.isFinite(c.lat) && Number.isFinite(c.lng));
  const center = cells.length
    ? [cells.reduce((s, c) => s + c.lat, 0) / cells.length, cells.reduce((s, c) => s + c.lng, 0) / cells.length]
    : DUISBURG;
  const token = process.env.REACT_APP_MAPBOX_TOKEN;
  const tileUrl = token
    ? `https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/256/{z}/{x}/{y}?access_token=${token}`
    : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

  return (
    <div>
      <div style={{ height: 400, borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
        <MapContainer center={center} zoom={11} style={{ height: '100%', width: '100%' }} scrollWheelZoom>
          <TileLayer url={tileUrl} attribution='&copy; OpenStreetMap, Mapbox' />
          {cells.map(c => {
            const lvl = rhoLevel(c.rho), f = factorOf(c.rho, dyn);
            return (
              <Circle key={c.zone} center={[c.lat, c.lng]} radius={cell * 55000} pathOptions={{ color: HEAT[lvl], weight: 1, fillColor: HEAT[lvl], fillOpacity: 0.35 }}>
                <Tooltip>{`ρ ${c.rho}${f != null ? ` · Faktor ${f.toFixed(2)}×` : ''} · ${LBL[lvl]} · ${c.requests || 0} Anfr · ${c.drivers || 0} Fahrer erreichbar`}</Tooltip>
              </Circle>
            );
          })}
        </MapContainer>
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 10, fontSize: 12, color: '#4b5563' }}>
        {LBL.map((n, i) => <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 11, height: 11, borderRadius: 3, background: HEAT[i] }} /> {n}</span>)}
        <span style={{ marginLeft: 'auto' }}>{cells.length} Zonen · Maus über Zelle = ρ + Faktor</span>
      </div>
      {!cells.length && <p style={{ fontSize: 13, color: '#4b5563', marginTop: 8 }}>Noch keine Live-Zonen. Sobald Fahrer online sind oder Anfragen laufen, erscheinen hier farbige Zonen auf der Karte.</p>}
    </div>
  );
}
